import {SWIREPAY_URL} from "../appconstants";

export default (host) => {
  let redirectUrl;
  if (host === 'localhost:4000') {
    redirectUrl = "http://localhost:4000/";
    return redirectUrl;
  } else  if (host === 'staging-secure.swirepay.com') {
    redirectUrl = "https://staging-secure.swirepay.com/";
    return redirectUrl;
  } else  if (host === 'secure.swirepay.com') {
    redirectUrl = "https://secure.swirepay.com/";
    return redirectUrl;
  } else {
    return SWIREPAY_URL;
  }
};